import $ from 'jquery';

export default function video() {
  
  function init() {
    $('.box-video .box-video__preview[role="button"][tabindex="0"]').on('keydown', function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        $(this).click();
      }
    });

    $('.modal.unindustria-modal.unindustria-modal--video').on('hidden.bs.modal', function () {
      const $iframe = $(this).find('iframe');
      $iframe.each(function () {
        this.src = this.src;
      });
    });
  }
  
  $( document ).ready(function() {
    if($('.box-video .box-video__preview').length > 0) {
      init();
    }
  });
}